"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requirementParamsSchema = exports.updateDocumentRequirementSchema = exports.addDocumentRequirementSchema = exports.listCaseDocumentsQuerySchema = exports.removeCaseDocumentSchema = exports.uploadCaseDocumentSchema = exports.insuranceDocStageEnum = exports.insuranceDocOwnerTypeEnum = exports.INSURANCE_DOC_TYPE_LABEL = exports.CLAIM_DOC_TYPES = exports.PRE_AUTH_DOC_TYPES = exports.listClaimsQuerySchema = exports.cancelClaimSchema = exports.claimReplySchema = exports.claimQuerySchema = exports.submitClaimDeskSchema = exports.createClaimDeskSchema = exports.ipClaimChannelEnum = exports.ipClaimTypeEnum = void 0;
const zod_1 = require("zod");
const ip_insurance_schema_1 = require("./ip-insurance.schema");
/**
 * INSURANCE MODULE, PHASE 3 (ADR-098) — the claims workbench and case documents.
 *
 * Accepting, rejecting and recording payment reuse the ADR-085 schemas
 * (`acceptClaimSchema`, `rejectClaimSchema`, `claimPaymentSchema`): their bodies are
 * exactly what the desk records. What is new is drafting with a type, sending with
 * a channel, the query loop, cancelling a draft, and documents.
 *
 * Amounts are integer paise.
 */
exports.ipClaimTypeEnum = zod_1.z.enum(['INTERIM', 'FINAL', 'SUPPLEMENTARY']);
exports.ipClaimChannelEnum = zod_1.z.enum(['EMAIL', 'PORTAL', 'COURIER', 'HAND_DELIVERY', 'OTHER']);
exports.createClaimDeskSchema = zod_1.z.object({
    ipAdmissionId: zod_1.z.string().uuid(),
    claimType: exports.ipClaimTypeEnum,
    /** Needed only when the stay's covered charges belong to more than one insurer. */
    payerId: zod_1.z.string().uuid().optional(),
    preAuthId: zod_1.z.string().uuid().optional(),
});
exports.submitClaimDeskSchema = zod_1.z.object({
    reference: zod_1.z.string().trim().max(100).optional(),
    channel: exports.ipClaimChannelEnum,
});
exports.claimQuerySchema = zod_1.z.object({ note: zod_1.z.string().trim().min(3).max(2000) });
exports.claimReplySchema = zod_1.z.object({
    note: zod_1.z.string().trim().min(3).max(2000),
    reference: zod_1.z.string().trim().max(100).optional(),
});
exports.cancelClaimSchema = zod_1.z.object({ reason: zod_1.z.string().trim().min(3).max(1000) });
exports.listClaimsQuerySchema = zod_1.z.object({
    /** Comma-separated, e.g. `DRAFT,SUBMITTED`. */
    status: zod_1.z
        .string()
        .transform((v) => v.split(',').map((x) => x.trim()).filter(Boolean))
        .pipe(zod_1.z.array(ip_insurance_schema_1.ipClaimStatusEnum).max(9))
        .optional(),
    type: exports.ipClaimTypeEnum.optional(),
    /** Claim number, patient name, UHID or admission number. */
    q: zod_1.z.string().trim().max(100).optional(),
    payerId: zod_1.z.string().uuid().optional(),
    admissionId: zod_1.z.string().uuid().optional(),
    page: zod_1.z.coerce.number().int().min(1).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(200).optional(),
});
// ---------------------------------------------------------------------------
// Document types. A CATALOGUE of labels the desk can put on an upload, NOT a list
// of what any insurer requires: that lives per insurer in
// `insurer_document_requirements` and is empty until filled from their contract.
// ---------------------------------------------------------------------------
exports.PRE_AUTH_DOC_TYPES = [
    'POLICY_CARD', 'PHOTO_ID', 'PRE_AUTH_FORM', 'DOCTORS_NOTE', 'INVESTIGATION_REPORT', 'ESTIMATE', 'OTHER',
];
exports.CLAIM_DOC_TYPES = [
    'DISCHARGE_SUMMARY', 'FINAL_BILL', 'PRE_AUTH_APPROVAL', 'CLAIM_FORM', 'INVESTIGATION_REPORTS',
    'PHARMACY_BILLS', 'OT_NOTES', 'IMPLANT_STICKERS', 'POLICY_CARD', 'PHOTO_ID', 'OTHER',
];
exports.INSURANCE_DOC_TYPE_LABEL = {
    POLICY_CARD: 'Policy card',
    PHOTO_ID: 'Photo ID',
    PRE_AUTH_FORM: 'Pre-authorisation form',
    DOCTORS_NOTE: "Doctor's note",
    INVESTIGATION_REPORT: 'Investigation report',
    ESTIMATE: 'Cost estimate',
    DISCHARGE_SUMMARY: 'Discharge summary',
    FINAL_BILL: 'Final bill',
    PRE_AUTH_APPROVAL: 'Pre-authorisation approval letter',
    CLAIM_FORM: 'Claim form',
    INVESTIGATION_REPORTS: 'Investigation reports',
    PHARMACY_BILLS: 'Pharmacy bills',
    OT_NOTES: 'Operation theatre notes',
    IMPLANT_STICKERS: 'Implant stickers / invoices',
    OTHER: 'Other',
};
exports.insuranceDocOwnerTypeEnum = zod_1.z.enum(['PRE_AUTH', 'CLAIM']);
exports.insuranceDocStageEnum = exports.insuranceDocOwnerTypeEnum;
const anyDocType = zod_1.z.enum([...new Set([...exports.PRE_AUTH_DOC_TYPES, ...exports.CLAIM_DOC_TYPES])]);
/** Multipart text fields arrive as strings; the file itself is not in the body. */
exports.uploadCaseDocumentSchema = zod_1.z.object({
    ownerType: exports.insuranceDocOwnerTypeEnum,
    ownerId: zod_1.z.string().uuid(),
    docType: anyDocType,
});
exports.removeCaseDocumentSchema = zod_1.z.object({ reason: zod_1.z.string().trim().min(3).max(500) });
exports.listCaseDocumentsQuerySchema = zod_1.z.object({
    ownerType: exports.insuranceDocOwnerTypeEnum,
    ownerId: zod_1.z.string().uuid(),
});
exports.addDocumentRequirementSchema = zod_1.z.object({
    stage: exports.insuranceDocStageEnum,
    docType: anyDocType,
    isRequired: zod_1.z.boolean().default(true),
});
exports.updateDocumentRequirementSchema = zod_1.z.object({ isRequired: zod_1.z.boolean() });
exports.requirementParamsSchema = zod_1.z.object({ id: zod_1.z.string().uuid(), requirementId: zod_1.z.string().uuid() });
//# sourceMappingURL=insurance-claims.schema.js.map